import { render, staticRenderFns } from "./IconLockOpenSolid.vue?vue&type=template&id=0c2b6c22"
import script from "./IconLockOpenSolid.vue?vue&type=script&lang=js"
export * from "./IconLockOpenSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports